module.exports = __webpack_public_path__ + "img/00053.1e47d9b4.webp";